"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "perugia": {
    "b2e6c991": [{
      "hkey": "9f8b263b",
      "slug": "montebello-ponte-san-giovanni",
      "name": "Montebello, Ponte San Giovanni",
      "primary": true,
      "skipSearch": false
    }],
    "altra-periferia": [{
      "hkey": "9f8b263b",
      "slug": "montebello-ponte-san-giovanni",
      "name": "Montebello, Ponte San Giovanni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "perugia"
    }],
    "a78e3eb0": [{
      "hkey": "495750a1",
      "slug": "bagnaia",
      "name": "Bagnaia",
      "primary": true,
      "skipSearch": false
    }],
    "bagnaia": [{
      "hkey": "495750a1",
      "slug": "bagnaia",
      "name": "Bagnaia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "bagnaia-castel-del-piano-pila"
    }],
    "f992a3fa": [{
      "hkey": "d7020532",
      "slug": "colombella-bosco",
      "name": "Colombella-Bosco",
      "primary": true,
      "skipSearch": false
    }],
    "bosco": [{
      "hkey": "d7020532",
      "slug": "colombella-bosco",
      "name": "Colombella-Bosco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "colombella-piccione-ramazzano"
    }],
    "04a36c56": [{
      "hkey": "5f3a8b0d",
      "slug": "capanne",
      "name": "Capanne",
      "primary": true,
      "skipSearch": false
    }],
    "capanne": [{
      "hkey": "5f3a8b0d",
      "slug": "capanne",
      "name": "Capanne",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "bagnaia-castel-del-piano-pila"
    }],
    "81b4caf1": [{
      "hkey": "9ac6c51d",
      "slug": "case-bruciate-fontivegge-via-xx-settembre",
      "name": "Case Bruciate-Fontivegge-Via XX Settembre",
      "primary": true,
      "skipSearch": false
    }],
    "case-bruciate": [{
      "hkey": "9ac6c51d",
      "slug": "case-bruciate-fontivegge-via-xx-settembre",
      "name": "Case Bruciate-Fontivegge-Via XX Settembre",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "centro-citta"
    }],
    "c301cd08": [{
      "hkey": "016248c3",
      "slug": "castel-del-piano",
      "name": "Castel del Piano",
      "primary": true,
      "skipSearch": false
    }],
    "castel-del-piano": [{
      "hkey": "016248c3",
      "slug": "castel-del-piano",
      "name": "Castel del Piano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "bagnaia-castel-del-piano-pila"
    }],
    "05412894": [{
      "hkey": "016248c3",
      "slug": "castel-del-piano",
      "name": "Castel del Piano",
      "primary": true,
      "skipSearch": false
    }],
    "castel-del-piano-umbro": [{
      "hkey": "016248c3",
      "slug": "castel-del-piano",
      "name": "Castel del Piano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "bagnaia-castel-del-piano-pila"
    }],
    "3f9240ef": [{
      "hkey": "19dfec8e",
      "slug": "cenerente",
      "name": "Cenerente",
      "primary": true,
      "skipSearch": false
    }],
    "cenerente": [{
      "hkey": "19dfec8e",
      "slug": "cenerente",
      "name": "Cenerente",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "cenerente-colle-umberto-i-migiana-di-monte-tezio"
    }],
    "87eb6ea9": [{
      "hkey": "61f76791",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": false
    }],
    "centro-storico": [{
      "hkey": "61f76791",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "centro-citta"
    }],
    "d266ff3a": [{
      "hkey": "61f76791",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": false
    }],
    "centro-storico-di-pregio": [{
      "hkey": "61f76791",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "centro-citta"
    }],
    "a8fc0136": [{
      "hkey": "2ebe809d",
      "slug": "olmo-citta-della-domenica",
      "name": "Olmo-Città della Domenica",
      "primary": true,
      "skipSearch": false
    }],
    "citta-della-domenica": [{
      "hkey": "2ebe809d",
      "slug": "olmo-citta-della-domenica",
      "name": "Olmo-Città della Domenica",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "perugia"
    }],
    "48432a9a": [{
      "hkey": "2637c868",
      "slug": "civitella-benazzone",
      "name": "Civitella Benazzone",
      "primary": true,
      "skipSearch": false
    }],
    "civitella-benazzone": [{
      "hkey": "2637c868",
      "slug": "civitella-benazzone",
      "name": "Civitella Benazzone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "civitella-benazzone-casa-del-diavolo-ponte-pattoli"
    }],
    "9ca7ca87": [{
      "hkey": "58ef7311",
      "slug": "colle-umberto-i",
      "name": "Colle Umberto I",
      "primary": true,
      "skipSearch": false
    }],
    "colle-umberto-i": [{
      "hkey": "58ef7311",
      "slug": "colle-umberto-i",
      "name": "Colle Umberto I",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "cenerente-colle-umberto-i-migiana-di-monte-tezio"
    }],
    "551825d1": [{
      "hkey": "021c11d1",
      "slug": "collestrada",
      "name": "Collestrada",
      "primary": true,
      "skipSearch": false
    }],
    "collestrada": [{
      "hkey": "021c11d1",
      "slug": "collestrada",
      "name": "Collestrada",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "collestrada-pianello-ripa-sant-egidio"
    }],
    "448a2ecf": [{
      "hkey": "d7020532",
      "slug": "colombella-bosco",
      "name": "Colombella-Bosco",
      "primary": true,
      "skipSearch": false
    }],
    "colombella": [{
      "hkey": "d7020532",
      "slug": "colombella-bosco",
      "name": "Colombella-Bosco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "colombella-piccione-ramazzano"
    }],
    "ae93e0e6": [{
      "hkey": "c5825b8f",
      "slug": "elce",
      "name": "Elce",
      "primary": true,
      "skipSearch": false
    }],
    "elce": [{
      "hkey": "c5825b8f",
      "slug": "elce",
      "name": "Elce",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "centro-citta"
    }],
    "bbad4aa2": [{
      "hkey": "64477e0e",
      "slug": "ferro-di-cavallo",
      "name": "Ferro di Cavallo",
      "primary": true,
      "skipSearch": false
    }],
    "ferro-di-cavallo": [{
      "hkey": "64477e0e",
      "slug": "ferro-di-cavallo",
      "name": "Ferro di Cavallo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "ferro-di-cavallo-madonna-alta"
    }],
    "a29444af": [{
      "hkey": "2ba607dd",
      "slug": "filosofi",
      "name": "Filosofi",
      "primary": true,
      "skipSearch": false
    }],
    "filosofi": [{
      "hkey": "2ba607dd",
      "slug": "filosofi",
      "name": "Filosofi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "centro-citta"
    }],
    "fc63a9d2": [{
      "hkey": "d1ee27c9",
      "slug": "fontignano",
      "name": "Fontignano",
      "primary": true,
      "skipSearch": false
    }],
    "fontignano": [{
      "hkey": "d1ee27c9",
      "slug": "fontignano",
      "name": "Fontignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "fontignano-mugnano-san-martino-dei-colli"
    }],
    "b5025735": [{
      "hkey": "e81d16a7",
      "slug": "piccione-fratticiola-selvatica",
      "name": "Piccione-Fratticiola Selvatica",
      "primary": true,
      "skipSearch": false
    }],
    "fratticiola-selvatica": [{
      "hkey": "e81d16a7",
      "slug": "piccione-fratticiola-selvatica",
      "name": "Piccione-Fratticiola Selvatica",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "colombella-piccione-ramazzano"
    }],
    "b358261d": [{
      "hkey": "b9cb9594",
      "slug": "la-bruna",
      "name": "La Bruna",
      "primary": true,
      "skipSearch": false
    }],
    "la-bruna": [{
      "hkey": "b9cb9594",
      "slug": "la-bruna",
      "name": "La Bruna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "la-cinella-parlesca-san-giovanni-del-pantano"
    }],
    "851e8fa6": [{
      "hkey": "9ac6c51d",
      "slug": "case-bruciate-fontivegge-via-xx-settembre",
      "name": "Case Bruciate-Fontivegge-Via XX Settembre",
      "primary": true,
      "skipSearch": false
    }],
    "case-bruciate-fortivegge-via-xx-settembre": [{
      "hkey": "9ac6c51d",
      "slug": "case-bruciate-fontivegge-via-xx-settembre",
      "name": "Case Bruciate-Fontivegge-Via XX Settembre",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": null
    }],
    "159d5bc0": [{
      "hkey": "840cba16",
      "slug": "la-cinella",
      "name": "La Cinella",
      "primary": true,
      "skipSearch": false
    }],
    "la-cinella": [{
      "hkey": "840cba16",
      "slug": "la-cinella",
      "name": "La Cinella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "la-cinella-parlesca-san-giovanni-del-pantano"
    }],
    "4621cd5e": [{
      "hkey": "2dfbbc10",
      "slug": "lacugnano",
      "name": "Lacugnano",
      "primary": true,
      "skipSearch": false
    }],
    "lacugnano": [{
      "hkey": "2dfbbc10",
      "slug": "lacugnano",
      "name": "Lacugnano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "lacugnano-ponte-della-pietra-san-sisto"
    }],
    "cc9c5a2a": [{
      "hkey": "8f5cc6ce",
      "slug": "madonna-alta",
      "name": "Madonna Alta",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-alta": [{
      "hkey": "8f5cc6ce",
      "slug": "madonna-alta",
      "name": "Madonna Alta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "ferro-di-cavallo-madonna-alta"
    }],
    "a11beaae": [{
      "hkey": "a1a80ca7",
      "slug": "migiana-di-monte-tezio",
      "name": "Migiana di Monte Tezio",
      "primary": true,
      "skipSearch": false
    }],
    "migiana-di-monte-tezio": [{
      "hkey": "a1a80ca7",
      "slug": "migiana-di-monte-tezio",
      "name": "Migiana di Monte Tezio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "cenerente-colle-umberto-i-migiana-di-monte-tezio"
    }],
    "b5dfbe17": [{
      "hkey": "dc72561d",
      "slug": "montebello",
      "name": "Montebello",
      "primary": true,
      "skipSearch": false
    }],
    "monte-corneo": [{
      "hkey": "dc72561d",
      "slug": "montebello",
      "name": "Montebello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "montebello-ponte-san-giovanni"
    }],
    "38147248": [{
      "hkey": "82e66c45",
      "slug": "montepetriolo",
      "name": "Montepetriolo",
      "primary": true,
      "skipSearch": false
    }],
    "monte-petriolo": [{
      "hkey": "82e66c45",
      "slug": "montepetriolo",
      "name": "Montepetriolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "fontignano-mugnano-san-martino-dei-colli"
    }],
    "a0762245": [{
      "hkey": "dc72561d",
      "slug": "montebello",
      "name": "Montebello",
      "primary": true,
      "skipSearch": false
    }],
    "montebello": [{
      "hkey": "dc72561d",
      "slug": "montebello",
      "name": "Montebello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "montebello-ponte-san-giovanni"
    }],
    "aa325add": [{
      "hkey": "c5d99fe6",
      "slug": "monteluce",
      "name": "Monteluce",
      "primary": true,
      "skipSearch": false
    }],
    "monteluce": [{
      "hkey": "c5d99fe6",
      "slug": "monteluce",
      "name": "Monteluce",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "centro-citta"
    }],
    "eec6fc9b": [{
      "hkey": "5e2c7fad",
      "slug": "mugnano",
      "name": "Mugnano",
      "primary": true,
      "skipSearch": false
    }],
    "mugnano": [{
      "hkey": "5e2c7fad",
      "slug": "mugnano",
      "name": "Mugnano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "fontignano-mugnano-san-martino-dei-colli"
    }],
    "9cba3bfc": [{
      "hkey": "2ebe809d",
      "slug": "olmo-citta-della-domenica",
      "name": "Olmo-Città della Domenica",
      "primary": true,
      "skipSearch": false
    }],
    "olmo": [{
      "hkey": "2ebe809d",
      "slug": "olmo-citta-della-domenica",
      "name": "Olmo-Città della Domenica",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "perugia"
    }],
    "819dfc2f": [{
      "hkey": "43c1cb47",
      "slug": "parlesca-rancolfo-solfagnano",
      "name": "Parlesca-Rancolfo-Solfagnano",
      "primary": true,
      "skipSearch": false
    }],
    "parlesca": [{
      "hkey": "43c1cb47",
      "slug": "parlesca-rancolfo-solfagnano",
      "name": "Parlesca-Rancolfo-Solfagnano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "la-cinella-parlesca-san-giovanni-del-pantano"
    }],
    "8f49531e": [{
      "hkey": "5b48da5c",
      "slug": "pianello",
      "name": "Pianello",
      "primary": true,
      "skipSearch": false
    }],
    "pianello": [{
      "hkey": "5b48da5c",
      "slug": "pianello",
      "name": "Pianello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "collestrada-pianello-ripa-sant-egidio"
    }],
    "9a5f86bf": [{
      "hkey": "e81d16a7",
      "slug": "piccione-fratticiola-selvatica",
      "name": "Piccione-Fratticiola Selvatica",
      "primary": true,
      "skipSearch": false
    }],
    "piccione": [{
      "hkey": "e81d16a7",
      "slug": "piccione-fratticiola-selvatica",
      "name": "Piccione-Fratticiola Selvatica",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "colombella-piccione-ramazzano"
    }],
    "d619e31f": [{
      "hkey": "823f5d8d",
      "slug": "pila",
      "name": "Pila",
      "primary": true,
      "skipSearch": false
    }],
    "pila": [{
      "hkey": "823f5d8d",
      "slug": "pila",
      "name": "Pila",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "bagnaia-castel-del-piano-pila"
    }],
    "7d93cbc7": [{
      "hkey": "f0b9e554",
      "slug": "pilonico-materno",
      "name": "Pilonico Materno",
      "primary": true,
      "skipSearch": false
    }],
    "pilonico-materno": [{
      "hkey": "f0b9e554",
      "slug": "pilonico-materno",
      "name": "Pilonico Materno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "bagnaia-castel-del-piano-pila"
    }],
    "1f0c5401": [{
      "hkey": "165fe87b",
      "slug": "ponte-della-pietra",
      "name": "Ponte della Pietra",
      "primary": true,
      "skipSearch": false
    }],
    "poggio-della-pietra": [{
      "hkey": "165fe87b",
      "slug": "ponte-della-pietra",
      "name": "Ponte della Pietra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "lacugnano-ponte-della-pietra-san-sisto"
    }],
    "ec078aa0": [{
      "hkey": "27d9ee28",
      "slug": "poggio-delle-corti",
      "name": "Poggio delle Corti",
      "primary": true,
      "skipSearch": false
    }],
    "poggio-delle-corti": [{
      "hkey": "27d9ee28",
      "slug": "poggio-delle-corti",
      "name": "Poggio delle Corti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "bagnaia-castel-del-piano-pila"
    }],
    "6c7e923f": [{
      "hkey": "396e212f",
      "slug": "ponte-felcino",
      "name": "Ponte Felcino",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-felcino": [{
      "hkey": "396e212f",
      "slug": "ponte-felcino",
      "name": "Ponte Felcino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "ponte-felcino-ponte-valleceppi-villa-pitignano"
    }],
    "61fc150f": [{
      "hkey": "a07b318a",
      "slug": "casa-del-diavolo-ponte-pattoli",
      "name": "Casa del Diavolo-Ponte Pattoli",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-pattoli": [{
      "hkey": "a07b318a",
      "slug": "casa-del-diavolo-ponte-pattoli",
      "name": "Casa del Diavolo-Ponte Pattoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "civitella-benazzone-casa-del-diavolo-ponte-pattoli"
    }],
    "27a53038": [{
      "hkey": "6c86be73",
      "slug": "montelaguardia-ponte-rio",
      "name": "Montelaguardia-Ponte Rio",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-rio": [{
      "hkey": "6c86be73",
      "slug": "montelaguardia-ponte-rio",
      "name": "Montelaguardia-Ponte Rio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "casaglia-pretola-montelaguardia-ponte-rio"
    }],
    "4e111386": [{
      "hkey": "de546e18",
      "slug": "ponte-san-giovanni",
      "name": "Ponte San Giovanni",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-san-giovanni": [{
      "hkey": "de546e18",
      "slug": "ponte-san-giovanni",
      "name": "Ponte San Giovanni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "montebello-ponte-san-giovanni"
    }],
    "77c6f69a": [{
      "hkey": "86dc3017",
      "slug": "ponte-valleceppi",
      "name": "Ponte Valleceppi",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-valleceppi": [{
      "hkey": "86dc3017",
      "slug": "ponte-valleceppi",
      "name": "Ponte Valleceppi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "ponte-felcino-ponte-valleceppi-villa-pitignano"
    }],
    "eecce84f": [{
      "hkey": "af82bda3",
      "slug": "prepo",
      "name": "Prepo",
      "primary": true,
      "skipSearch": false
    }],
    "prepo": [{
      "hkey": "af82bda3",
      "slug": "prepo",
      "name": "Prepo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "ferro-di-cavallo-madonna-alta"
    }],
    "8172a4a8": [{
      "hkey": "16e71940",
      "slug": "casaglia-pretola",
      "name": "Casaglia-Pretola",
      "primary": true,
      "skipSearch": false
    }],
    "pretola": [{
      "hkey": "16e71940",
      "slug": "casaglia-pretola",
      "name": "Casaglia-Pretola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "casaglia-pretola-montelaguardia-ponte-rio"
    }],
    "175909a2": [{
      "hkey": "18b00ca2",
      "slug": "ramazzano",
      "name": "Ramazzano",
      "primary": true,
      "skipSearch": false
    }],
    "ramazzano": [{
      "hkey": "18b00ca2",
      "slug": "ramazzano",
      "name": "Ramazzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "colombella-piccione-ramazzano"
    }],
    "f3ea1dbf": [{
      "hkey": "43c1cb47",
      "slug": "parlesca-rancolfo-solfagnano",
      "name": "Parlesca-Rancolfo-Solfagnano",
      "primary": true,
      "skipSearch": false
    }],
    "rancolfo": [{
      "hkey": "43c1cb47",
      "slug": "parlesca-rancolfo-solfagnano",
      "name": "Parlesca-Rancolfo-Solfagnano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "la-cinella-parlesca-san-giovanni-del-pantano"
    }],
    "6ba3f165": [{
      "hkey": "a437b6b6",
      "slug": "ripa-sant-egidio",
      "name": "Ripa-Sant'Egidio",
      "primary": true,
      "skipSearch": false
    }],
    "ripa": [{
      "hkey": "a437b6b6",
      "slug": "ripa-sant-egidio",
      "name": "Ripa-Sant'Egidio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "collestrada-pianello-ripa-sant-egidio"
    }],
    "3a31ae8e": [{
      "hkey": "8ee2faf2",
      "slug": "san-fortunato-della-collina",
      "name": "San Fortunato della Collina",
      "primary": true,
      "skipSearch": false
    }],
    "san-fortunato-della-collina": [{
      "hkey": "8ee2faf2",
      "slug": "san-fortunato-della-collina",
      "name": "San Fortunato della Collina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "sant-enea-san-martino-in-campo-san-martino-in-colle"
    }],
    "40df372f": [{
      "hkey": "d474e43c",
      "slug": "san-giovanni-del-pantano",
      "name": "San Giovanni del Pantano",
      "primary": true,
      "skipSearch": false
    }],
    "san-giovanni-del-pantano": [{
      "hkey": "d474e43c",
      "slug": "san-giovanni-del-pantano",
      "name": "San Giovanni del Pantano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "la-cinella-parlesca-san-giovanni-del-pantano"
    }],
    "18ba5a7f": [{
      "hkey": "5e7294a1",
      "slug": "san-marco-montegrillo",
      "name": "San Marco-Montegrillo",
      "primary": true,
      "skipSearch": false
    }],
    "san-marco": [{
      "hkey": "5e7294a1",
      "slug": "san-marco-montegrillo",
      "name": "San Marco-Montegrillo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "perugia"
    }],
    "c37f5a13": [{
      "hkey": "b0f90959",
      "slug": "san-martino-in-colle",
      "name": "San Martino in Colle",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino-in-colle": [{
      "hkey": "b0f90959",
      "slug": "san-martino-in-colle",
      "name": "San Martino in Colle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "sant-enea-san-martino-in-campo-san-martino-in-colle"
    }],
    "fa31675d": [{
      "hkey": "e5288deb",
      "slug": "san-sisto",
      "name": "San Sisto",
      "primary": true,
      "skipSearch": false
    }],
    "san-sisto": [{
      "hkey": "e5288deb",
      "slug": "san-sisto",
      "name": "San Sisto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "lacugnano-ponte-della-pietra-san-sisto"
    }],
    "2f464107": [{
      "hkey": "a437b6b6",
      "slug": "ripa-sant-egidio",
      "name": "Ripa-Sant'Egidio",
      "primary": true,
      "skipSearch": false
    }],
    "sant-egidio": [{
      "hkey": "a437b6b6",
      "slug": "ripa-sant-egidio",
      "name": "Ripa-Sant'Egidio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "collestrada-pianello-ripa-sant-egidio"
    }],
    "67113f3e": [{
      "hkey": "176c60e3",
      "slug": "sant-enea",
      "name": "Sant'Enea",
      "primary": true,
      "skipSearch": false
    }],
    "sant-enea": [{
      "hkey": "176c60e3",
      "slug": "sant-enea",
      "name": "Sant'Enea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "sant-enea-san-martino-in-campo-san-martino-in-colle"
    }],
    "439ccaf5": [{
      "hkey": "f45506fa",
      "slug": "santa-lucia",
      "name": "Santa Lucia",
      "primary": true,
      "skipSearch": false
    }],
    "santa-lucia": [{
      "hkey": "f45506fa",
      "slug": "santa-lucia",
      "name": "Santa Lucia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "ferro-di-cavallo-madonna-alta"
    }],
    "e1d0fcce": [{
      "hkey": "90291a80",
      "slug": "santa-maria-rossa",
      "name": "Santa Maria Rossa",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria-rossa": [{
      "hkey": "90291a80",
      "slug": "santa-maria-rossa",
      "name": "Santa Maria Rossa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "sant-enea-san-martino-in-campo-san-martino-in-colle"
    }],
    "d9ef1f1f": [{
      "hkey": "43c1cb47",
      "slug": "parlesca-rancolfo-solfagnano",
      "name": "Parlesca-Rancolfo-Solfagnano",
      "primary": true,
      "skipSearch": false
    }],
    "solfagnano": [{
      "hkey": "43c1cb47",
      "slug": "parlesca-rancolfo-solfagnano",
      "name": "Parlesca-Rancolfo-Solfagnano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "la-cinella-parlesca-san-giovanni-del-pantano"
    }],
    "e30a17e0": [{
      "hkey": "9ac6c51d",
      "slug": "case-bruciate-fontivegge-via-xx-settembre",
      "name": "Case Bruciate-Fontivegge-Via XX Settembre",
      "primary": true,
      "skipSearch": false
    }],
    "stazione": [{
      "hkey": "9ac6c51d",
      "slug": "case-bruciate-fontivegge-via-xx-settembre",
      "name": "Case Bruciate-Fontivegge-Via XX Settembre",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "centro-citta"
    }],
    "c4364a41": [{
      "hkey": "9ac6c51d",
      "slug": "case-bruciate-fontivegge-via-xx-settembre",
      "name": "Case Bruciate-Fontivegge-Via XX Settembre",
      "primary": true,
      "skipSearch": false
    }],
    "via-xx-settembre": [{
      "hkey": "9ac6c51d",
      "slug": "case-bruciate-fontivegge-via-xx-settembre",
      "name": "Case Bruciate-Fontivegge-Via XX Settembre",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "centro-citta"
    }],
    "13b835dc": [{
      "hkey": "aea1b10b",
      "slug": "villa-pitignano",
      "name": "Villa Pitignano",
      "primary": true,
      "skipSearch": false
    }],
    "villa-pitignano": [{
      "hkey": "aea1b10b",
      "slug": "villa-pitignano",
      "name": "Villa Pitignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "ponte-felcino-ponte-valleceppi-villa-pitignano"
    }]
  }
};
exports["default"] = _default;